<template>

  <div class="Safety">

      <b-container fluid style="padding-top: 100px;text-align:left">
        <b-row>
          <b-col cols="12 headerF"><HeaderFixed/></b-col>
          <b-col cols="12 headerM"><HeaderMobile/></b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
              <b-breadcrumb style=" background-color: #e9ecef78;">
                  <b-breadcrumb-item href="#home">
                    <router-link to="/">
                        <b-icon icon="house-door" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
                        Home
                    </router-link>
                  </b-breadcrumb-item>

                 <b-breadcrumb-item href="#" active>PM Surya Ghar : Muft Bijli Yojana</b-breadcrumb-item>
              </b-breadcrumb>
            </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <span class="title">PM Surya Ghar : Muft Bijli Yojana</span>
          </b-col>
        </b-row>
        <hr/>
        <div class="paddingLeft30px">

        <div id="" class="">
          <br>
          <ul>
          <li>
              <span>  <b-img src="../assets/pdf-icon-3.png" height="35px" width="35px" style="padding-bottom:0px" />
             </span>
               <a href="https://www.apdcl.org/website/docs/documents/pmsurya/Notification-Operational Guidelines.pdf" target="_blank">
                Operational Guidelines
               </a>
          </li>
          <br>
          <li>
            <span>  <b-img src="../assets/pdf-icon-3.png" height="35px" width="35px" style="padding-bottom:0px" />
             </span>
            <a href="https://www.apdcl.org/website/docs/documents/pmsurya/Notification_for Empanellment of Vendors.pdf" target="_blank">
                Notice for Empanelment of Vendors
               </a>
          </li>
          <br>
          <li>
            <a href="https://pmsuryaghar.gov.in/" target="_blank">
              <b-icon size="lg" icon="chevron-double-right" aria-hidden="true"></b-icon> Click here for Consumer Registration
               </a>
          </li>
          <br>
          <li>
            <a href="https://www.apdcl.org/pmsurya/login" target="_blank">
              <b-icon size="lg" icon="chevron-double-right" aria-hidden="true"></b-icon> Click here for Vendor Registration for PM Surya Ghar
               </a>
          </li>
          <br>
          <li>
            <a href="https://pmsuryaghar.gov.in/#/capacity-building" target="_blank">
              <b-icon size="lg" icon="chevron-double-right" aria-hidden="true"></b-icon> Click here for MANPOWER FOR VENDOR UTILISATION (List of available Certified Solar PV Installers under PM-Surya Ghar Yojana)
               </a>
          </li>
          <br>
          <li>
            <span style="color: #0056b3"><b-icon size="lg" icon="phone" aria-hidden="true"></b-icon> Contact No. <span style="font-weight: bold;">8399883941</span> <span style="color: orangered">(Operational during office hours only)</span></span>
          </li>
        </ul>
        <br><br>
    </div>
</div>
  </b-container>
  <br>
  </div>

</template>


<script>

import HeaderFixed from '@/components/HeaderFixed.vue'
import HeaderMobile from '@/components/HeaderMobile.vue'
//import MarqueeText from 'vue-marquee-text-component'
//console.log(Banner);


export default {
  name: 'PayBill',
  components: {

    'HeaderFixed' : HeaderFixed,
    'HeaderMobile' : HeaderMobile
    //MarqueeText

  },
  computed: {

  },
  data() {
    return {

    }
  },
  methods: {

  }
}

</script>

<style scoped="true">
.label{

}
.data{
  font-weight: 500;
  color: #e64a19      ;
  font-size: 1.1rem;
  padding-top: 10px;
}

hr {
   margin-top: 5px;
   margin-bottom: 5px;
  }
.go:focus{
  box-shadow: none;
}
.headerF{
  display: block;
}
.headerM{
  display: none;
}
.paddingLeft30px{
  padding-left: 30px;
}
@media (max-width: 768px) {
    .headerF{
      display: none;
    }
    .headerM{
      display: block;
    }
    .paddingLeft30px{
      padding-left: 0px;
    }
}
</style>
